import script from "./PtoConfigRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./PtoConfigRow.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__